import classNames from 'classnames'
import { Field, useField } from 'formik'

import { IconAlert, IconCheck } from '@/components/Icons'

type Props = {
  name: string
  value?: string | number
  label: string | JSX.Element
}

const Checkbox: React.FC<React.PropsWithChildren<Props>> = ({ ...props }) => {
  const [field, { touched, error }] = useField(props)
  const hasError = touched && error && typeof error === 'string'
  const isChecked = Array.isArray(field.value) ? field.value?.includes(props.value) : field.value

  return (
    <>
      <label className="group flex cursor-pointer items-center space-x-3 py-2" htmlFor={props.value?.toString()}>
        <div
          className={classNames(
            'flex h-6 w-6 shrink items-center justify-center rounded-sm',
            isChecked ? 'bg-purple-extra-light' : 'ring-1 ring-grey-light group-hover:ring-purple-light',
          )}
        >
          {isChecked ? <IconCheck className="icon-xs text-purple-base" /> : null}
        </div>

        <div className="flex-1 text-base">{props.label}</div>

        {/* Input hidden to achieve our custom checkbox design. */}
        <Field id={props.value} {...props} type="checkbox" className="absolute h-1 w-1 opacity-0" />
      </label>

      {hasError ? (
        <div className="flex items-center text-red-base text-sm">
          <IconAlert className="fill-current icon-xs mr-1 inline-block text-red-base" />
          {error}
        </div>
      ) : null}
    </>
  )
}

export default Checkbox
